const state = {
  is_show_success: false,
  message: '',
  meta: null,
};

const mutations = {
  is_show_success(state, v) { state.is_show_success = v; },
  message(state, v) { state.message = v; },
  meta(state, v) { state.meta = v; },
};

const actions = {
  show({ commit }, { msg, meta = null }) {
    console.debug('success/show called:', { msg, meta });
    commit('message', msg);
    commit('meta', meta);
    commit('is_show_success', true);
  },
  hide({ commit }) {
    commit('message', '');
    commit('meta', null);
    commit('is_show_success', false);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};


